import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import { IconButton, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useNavigate } from "react-router";

import { buildSearchResultsUrl } from "~/feature/search/utils/buildSearchResultsUrl";

import * as Styled from "./RecentSection.styles";

interface IRecentSectionProps {
  items: string[];
  onRemove: (query: string) => void;
  onNavigate?: () => void;
}

export const RecentSection: FC<IRecentSectionProps> = ({
  items,
  onRemove,
  onNavigate,
}) => {
  const navigate = useNavigate();

  if (items.length === 0) return null;

  const handleClick = (query: string) => {
    navigate(buildSearchResultsUrl(query));
    onNavigate?.();
  };

  return (
    <Stack
      sx={{
        gap: 0.5,
        px: 1.5,
        py: 1.25
      }}>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 0.5
        }}>
        Recent
      </Typography>
      <Stack>
        {items.map((query) => (
          <Styled.Item key={query}>
            <Styled.ClickArea
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleClick(query)}
            >
              <HistoryIcon fontSize="small" color="disabled" />
              <Typography variant="body2" sx={{ textTransform: "capitalize" }}>{query}</Typography>
            </Styled.ClickArea>
            <IconButton
              size="small"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => onRemove(query)}
              sx={{ opacity: 0.4, "&:hover": { opacity: 1 } }}
            >
              <CloseIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Styled.Item>
        ))}
      </Stack>
    </Stack>
  );
};
